import { format } from 'date-fns';
import React from 'react';
import MaskedInput from 'react-maskedinput';

import { i18n } from 'translate/i18n';

import logoImg from '../../../../../assets/images/favicon.png'

import '../../style.css'

function ChatPreview({ setPreview,
   save,
   defaultColor, 
   backgroundColorChat, 
   backgroundColorUserAnswer, 
   backgroundColorCompanyAnswer 
}) {

  return (
    <div className="container">
      <div className="container-previews">
        <div style={{width: '30vw'}}>
        <>
          <header
            className="header-client-chat"
            style={{ backgroundColor: defaultColor, height: 65.38 }}
          >
            <div className="box-left-client-chat">
              <span>{i18n.t('howCanHelp')}</span> 
            </div>
          </header>
          <div className="contain-client-chat" style={{backgroundColor: backgroundColorChat}}>
            <>
              <div className="contain-title-area-client-chat">
                <span>
                  {i18n.t('infoToStart')}
                </span>
              </div>
              <form>
                <input
                  required
                  placeholder={i18n.t('name') + ' *'}
                  style={{ borderColor: backgroundColorCompanyAnswer }}
                />
                <MaskedInput
                  mask="+11 (11) 11111-1111"
                  required
                  placeholder="+99 (99) 99999-9999 *"
                  style={{ borderColor: backgroundColorCompanyAnswer }}
                />
                <input
                  required
                  type="email"
                  placeholder="seuemail@email.com *"
                  style={{ borderColor: backgroundColorCompanyAnswer }}
                />
                <button
                  type="submit"
                  style={{
                    backgroundColor: defaultColor,
                    marginColor: defaultColor,
                  }}
                >
                  {i18n.t('start')}
                </button>
              </form>
            </>
          </div>
        </>
        </div>
        <div style={{width: '30vw', marginLeft: 30}}>
          <header
            className="header-client-chat"
            style={{ backgroundColor: defaultColor }}
          >
            <div className="box-left-client-chat">
              <span>{i18n.t('howCanHelp')}</span> 
            </div>
              <button
                type="button"
                className="btn btn-danger"
                style={{ marginLeft: 0 }}
              > 
                <i className="uil uil-exit" style={{ fontSize: 17 }}></i>
              </button>
          </header>
          <div className="contain-client-chat" style={{backgroundColor: backgroundColorChat, paddingRight: 5, paddingLeft: 5}}>
            <div style={{height: '100%', width: '100%'}}>
              <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <img alt="user" height="40" width="40" src={logoImg}/>
                  {format(new Date(), "HH:mm")}
                </div>
                <div className="chat-message" style={{backgroundColor: backgroundColorCompanyAnswer}}>
                  <div style={{fontStyle: 'italic'}}>EMPRESA X</div>
                  <span className="company-answer">Olá teste! Seu protocolo de atendimento é 2021061117271901408. Em alguns instantes iremos atendê-lo.</span>
                </div>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <img alt="user" height="40" width="40" src={logoImg}/>
                  {format(new Date(), "HH:mm")}
                </div>
                <div className="chat-user" style={{backgroundColor: backgroundColorUserAnswer}}>
                  <div style={{fontStyle: 'italic'}}>Usuário X</div>
                  <span className="company-answer">Olá, estou com um problema</span>
                </div>
              </div>
            </div>
            <div className="area-input-chat-component">
              <form>
                <div style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center'}}>
                  <input style={{marginTop: 15}}/>
                  <div>
                    <div
                      style={{
                        marginLeft: 5,
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <>
                        <button
                          className="btn btn-light"
                          disabled
                          style={{
                            backgroundColor: "#ddd",
                            border: "1px",
                            padding: 0,
                          }}
                        >
                          <label
                            htmlFor="file-input"
                            className="uil uil-paperclip"
                            style={{
                              display: "flex",
                              width: "100%",
                              height: "100%",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              padding: 11,
                            }}
                          ></label>

                        </button>

                        <button
                          type="submit"
                          disabled
                          className="btn btn-success"
                          style={{ marginLeft: 0 }}
                        >
                          <i className="uil uil-message"></i>
                        </button>
                      </>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="button-list mt-3 pull-right"
        style={{ position: "absolute", bottom: 0, right: 0 }}
      >
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={() => setPreview(false)}
        >
          <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('getBack')}
        </button>
        <button 
          type="submit" 
          className="btn btn-outline-success"
          onClick={save}
        >
          <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
        </button>
      </div>
    </div>
  );
}

export default ChatPreview;